import { NavItem, ProfileNavItem as ProfileNavItemBase } from '@/components/dashboard';
import { ActionButton } from '@/components/dashboard/action-button';
import { Link } from '@tanstack/react-router';
import { Button, concreteComponent, applyProps } from 'ht-sdk/react';
import { Copy, Eye, Pencil, Plus, Trash2, User } from 'lucide-react';

// TODO: fix type inference for concreteComponent
// currently it forces you to implement props from NavItem but not from Link
export const NavLink = concreteComponent(NavItem, Link);

export const ProfileNavItem = applyProps(ProfileNavItemBase, { userIcon: User });

export const LinkButton = concreteComponent(Button, Link);

export const CreateButton = applyProps(Button, { as: Link, iconRight: Plus });

export const EditButton = applyProps(ActionButton, { iconLeft: Pencil, as: Link });

export const ViewButton = applyProps(ActionButton, { iconLeft: Eye, as: Link });

// TODO: fix type inference for applyProps
export const CopyButton = applyProps(ActionButton, { iconLeft: Copy });
export const DeleteButton = applyProps(ActionButton, { iconLeft: Trash2 });
